import { StructuredLogLevel } from "@modules/graphql/types"
import {
  useStructuredLogsForBuildQuery,
  useStructuredLogCreatedSubscription,
} from "@modules/build/logs/structured/queries.generated"
import { ApolloStatus } from "@modules/enums/constants"

export const useStructuredLogs = ({
  buildId,
  siteId,
  logLevel = StructuredLogLevel.All,
}: {
  buildId: string
  siteId: string
  logLevel: StructuredLogLevel
}) => {
  const {
    data,
    error,
    loading,
    refetch,
    networkStatus,
  } = useStructuredLogsForBuildQuery({
    variables: {
      buildId,
      siteId,
      logLevel,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: `cache-and-network`,
  })

  useStructuredLogCreatedSubscription({
    variables: {
      buildId,
    },
    onSubscriptionData: () => refetch(),
  })

  const isWaiting = loading && networkStatus !== ApolloStatus.Refetching

  const structuredLogsForBuild = data?.structuredLogsForBuild || []

  return [
    structuredLogsForBuild,
    {
      loading: isWaiting,
      error,
      refetch,
    },
  ] as const
}
